import { render, staticRenderFns } from "./LiveAssignmentButton.vue?vue&type=template&id=b071fe48&scoped=true"
import script from "./LiveAssignmentButton.vue?vue&type=script&lang=js"
export * from "./LiveAssignmentButton.vue?vue&type=script&lang=js"
import style0 from "./LiveAssignmentButton.vue?vue&type=style&index=0&id=b071fe48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b071fe48",
  null
  
)

export default component.exports